import { render } from "./CommentItem.vue?vue&type=template&id=6454bc08&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"

import "./CommentItem.vue?vue&type=style&index=0&id=6454bc08&lang=scss&scoped=true"
import "./CommentItem.vue?vue&type=style&index=1&id=6454bc08&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6454bc08"]])

export default __exports__